import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface GeneratedIdea {
  id: number;
  trigger_event_name: string;
  trigger_event_date: string;
  idea_headline: string;
  idea_type: string;
  idea_details: string;
  rationale: string;
  quick_win_details: string;
  created_at: string;
  color_theme: string[];
}

export interface GeneratedIdeasResponse {
  restaurantId: string;
  count: number;
  data: GeneratedIdea[];
}

export interface GeneratedIdeasState {
  loading: boolean;
  error: string | null;
  ideas: GeneratedIdea[];
  count: number;
  restaurantId: string | null;
}

const initialState: GeneratedIdeasState = {
  loading: false,
  error: null,
  ideas: [],
  count: 0,
  restaurantId: null,
};

const generatedIdeasSlice = createSlice({
  name: 'generatedIdeas',
  initialState,
  reducers: {
    fetchGeneratedIdeasRequest: (state, action: PayloadAction<{ restaurantId: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchGeneratedIdeasSuccess: (state, action: PayloadAction<GeneratedIdeasResponse>) => {
      state.loading = false;
      state.ideas = action.payload.data;
      state.count = action.payload.count;
      state.restaurantId = action.payload.restaurantId;
      state.error = null;
    },
    fetchGeneratedIdeasFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.ideas = [];
      state.count = 0;
    },
    clearGeneratedIdeas: (state) => {
      state.ideas = [];
      state.count = 0;
      state.error = null;
      state.restaurantId = null;
    },
  },
});

export const {
  fetchGeneratedIdeasRequest,
  fetchGeneratedIdeasSuccess,
  fetchGeneratedIdeasFailure,
  clearGeneratedIdeas,
} = generatedIdeasSlice.actions;

export default generatedIdeasSlice.reducer;
